var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.dadosVtn.status !== "Aguardando cálculo" &&
    _vm.dadosVtn.status !== "AGUARDANDO_CALCULO" &&
    _vm.dadosVtn.status.toUpperCase() !== "CRIADO"
      ? _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("dados-modal-AP", {
                  attrs: {
                    dadosVtn: _vm.dadosVtn,
                    processo: _vm.dadosVtn.processo
                  }
                })
              ],
              1
            ),
            _c("app-divider", {
              staticClass: "margin10",
              attrs: { label: "Observações:" }
            }),
            _c("div", { staticClass: "card-body margin10" }, [
              _c("p", [
                _vm._v(
                  "- Cálculos efetuados com base no DECRETO Nº 1.684, de 29 de JUNHO de 2021; Lei Estadual nº 8.878, de 8 de julho de 2019 e DECRETO Nº 1.190, DE 25 / 11 / 2020."
                )
              ]),
              _vm.dadosVtn.processo.tipo.codigo === "ONEROSO"
                ? _c("p", [
                    _vm._v(
                      "- Reajuste pela UPFPA do em vigor e, caso opte pelo pagamento parcelado, será aplicados juros de " +
                        _vm._s(_vm.dadosVtn.juros) +
                        "% ao ano."
                    )
                  ])
                : _vm._e(),
              _vm.dadosVtn.processo.tipo.codigo === "ONEROSO" &&
              !(
                _vm.dadosVtn.respeitaLegislacaoAmbiental &&
                _vm.dadosVtn.temDireitoRegularizacao
              )
                ? _c("p", [
                    _vm._v(
                      "- Caso opte pelo pagamento à vista, será aplicado um desconto de 20%."
                    )
                  ])
                : _vm._e(),
              _vm.dadosVtn.respeitaLegislacaoAmbiental
                ? _c("p", [
                    _vm._v(
                      "- " + _vm._s(_vm.mensagemRespeitaLegislacaoAmbiental)
                    )
                  ])
                : _vm._e(),
              _vm.dadosVtn.temDireitoRegularizacao
                ? _c("p", [
                    _vm._v("- " + _vm._s(_vm.mensagemDireitoRegularizacao))
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      : _c("div", [
          _c("p", [_vm._v("Nenhuma informação disponível para este processo.")])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-693c1576", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-693c1576","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDadosCalculoVtnAP.vue
// module id = null
// module chunks = 